export const getPayloadLocale = (locale: string): string => {
  if (locale === 'sg') return 'en-SG'
  if (locale === 'au') return 'en-AU'
  if (locale === 'uk') return 'en-GB'
  if (locale === 'ca') return 'en-CA'
  if (locale === 'us') return 'en-US'
  if (locale === 'en-ae') return 'en-AR'
  if (locale === 'en-br') return 'en-BR'
  if (locale === 'eea') return 'en-EEA'
  if (locale === 'kr') return 'ko'
  if (locale === 'ae') return 'ar'
  if (locale === 'se') return 'sv'
  if (locale === 'zh') return 'zh-TW'
  return locale
}

export function toLocaleUrl(url: string | null, locale: string): string | null {
  if (!url) return null
  try {
    const { pathname, search, hash } = new URL(url)
    // Strip the first path segment (region code e.g. /sg) and prepend current locale
    // e.g. https://crypto.com/sg/events/x → /en/events/x
    const segments = pathname.split('/').filter(Boolean)
    const pathWithoutRegion = segments.length > 1 ? segments.slice(1).join('/') : segments.join('/')
    return `/${locale}/${pathWithoutRegion}${search}${hash}`
  } catch {
    return url
  }
}

const rewardApiLocaleMap: Record<string, string> = {
  'en-US': 'en_US',
  id: 'id_ID',
  da: 'da_DK',
  de: 'de_DE',
  'fr-CA': 'fr_CA',
  hr: 'hr_HR',
  hu: 'hu_HU',
  nl: 'nl_NL',
  pl: 'pl_PL',
  pt: 'pt_PT',
  'pt-BR': 'pt_BR',
  ru: 'ru_RU',
  ro: 'ro_RO',
  sk: 'sk_SK',
  fi: 'fi_FI',
  sv: 'sv_SE',
  tr: 'tr_TR',
  el: 'el_GR',
  hi: 'hi_IN',
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW',
}

export function toRewardApiLocaleCode(standardLocale: string): string {
  return rewardApiLocaleMap[standardLocale] ?? standardLocale
}

const alpha2ToAlpha3Map: Record<string, string> = {
  AF: 'AFG',
  AL: 'ALB',
  DZ: 'DZA',
  AD: 'AND',
  AO: 'AGO',
  AG: 'ATG',
  AR: 'ARG',
  AM: 'ARM',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  BS: 'BHS',
  BH: 'BHR',
  BD: 'BGD',
  BB: 'BRB',
  BY: 'BLR',
  BE: 'BEL',
  BZ: 'BLZ',
  BJ: 'BEN',
  BT: 'BTN',
  BO: 'BOL',
  BA: 'BIH',
  BW: 'BWA',
  BR: 'BRA',
  BN: 'BRN',
  BG: 'BGR',
  BF: 'BFA',
  BI: 'BDI',
  CV: 'CPV',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  CF: 'CAF',
  TD: 'TCD',
  CL: 'CHL',
  CN: 'CHN',
  CO: 'COL',
  KM: 'COM',
  CG: 'COG',
  CR: 'CRI',
  HR: 'HRV',
  CU: 'CUB',
  CY: 'CYP',
  CZ: 'CZE',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EC: 'ECU',
  EG: 'EGY',
  SV: 'SLV',
  GQ: 'GNQ',
  ER: 'ERI',
  EE: 'EST',
  SZ: 'SWZ',
  ET: 'ETH',
  FJ: 'FJI',
  FI: 'FIN',
  FR: 'FRA',
  GA: 'GAB',
  GM: 'GMB',
  GE: 'GEO',
  DE: 'DEU',
  GH: 'GHA',
  GR: 'GRC',
  GD: 'GRD',
  GT: 'GTM',
  GN: 'GIN',
  GW: 'GNB',
  GY: 'GUY',
  HT: 'HTI',
  HN: 'HND',
  HU: 'HUN',
  IS: 'ISL',
  IN: 'IND',
  ID: 'IDN',
  IR: 'IRN',
  IQ: 'IRQ',
  IE: 'IRL',
  IL: 'ISR',
  IT: 'ITA',
  JM: 'JAM',
  JP: 'JPN',
  JO: 'JOR',
  KZ: 'KAZ',
  KE: 'KEN',
  KI: 'KIR',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KG: 'KGZ',
  LA: 'LAO',
  LV: 'LVA',
  LB: 'LBN',
  LS: 'LSO',
  LR: 'LBR',
  LY: 'LBY',
  LI: 'LIE',
  LT: 'LTU',
  LU: 'LUX',
  MG: 'MDG',
  MW: 'MWI',
  MY: 'MYS',
  MV: 'MDV',
  ML: 'MLI',
  MT: 'MLT',
  MH: 'MHL',
  MR: 'MRT',
  MU: 'MUS',
  MX: 'MEX',
  FM: 'FSM',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  ME: 'MNE',
  MA: 'MAR',
  MZ: 'MOZ',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NL: 'NLD',
  NZ: 'NZL',
  NI: 'NIC',
  NE: 'NER',
  NG: 'NGA',
  NO: 'NOR',
  OM: 'OMN',
  PK: 'PAK',
  PW: 'PLW',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PH: 'PHL',
  PL: 'POL',
  PT: 'PRT',
  QA: 'QAT',
  RO: 'ROU',
  RU: 'RUS',
  RW: 'RWA',
  KN: 'KNA',
  LC: 'LCA',
  VC: 'VCT',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SN: 'SEN',
  RS: 'SRB',
  SC: 'SYC',
  SL: 'SLE',
  SG: 'SGP',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  ZA: 'ZAF',
  SS: 'SSD',
  ES: 'ESP',
  LK: 'LKA',
  SD: 'SDN',
  SR: 'SUR',
  SE: 'SWE',
  CH: 'CHE',
  SY: 'SYR',
  TW: 'TWN',
  TJ: 'TJK',
  TZ: 'TZA',
  TH: 'THA',
  TL: 'TLS',
  TG: 'TGO',
  TO: 'TON',
  TT: 'TTO',
  TN: 'TUN',
  TR: 'TUR',
  TM: 'TKM',
  TV: 'TUV',
  UG: 'UGA',
  UA: 'UKR',
  AE: 'ARE',
  GB: 'GBR',
  US: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  VU: 'VUT',
  VE: 'VEN',
  VN: 'VNM',
  YE: 'YEM',
  ZM: 'ZMB',
  ZW: 'ZWE',
}

export function toAlpha3CountryCode(alpha2: string): string {
  return alpha2ToAlpha3Map[alpha2.toUpperCase()] ?? alpha2
}

export function isCoinVisible(
  campaign: { coinMode: 'all' | 'specific' | 'all_except'; coins?: string | null },
  symbol: string,
): boolean {
  const upperSymbol = symbol.toUpperCase()
  const coinList = campaign.coins ? campaign.coins.split(',').map(s => s.trim().toUpperCase()) : []

  if (campaign.coinMode === 'all') return true
  if (campaign.coinMode === 'specific') return coinList.includes(upperSymbol)
  if (campaign.coinMode === 'all_except') return !coinList.includes(upperSymbol)
  return false
}

export const isVisibleForCountry = (
  allowedIps: string | undefined,
  restrictedIps: string | undefined,
  countryCode: string,
  regionCode: string,
): boolean => {
  const fullRegionCode =
    countryCode && regionCode ? `${countryCode}-${regionCode}`.toUpperCase() : ''

  if (allowedIps) {
    const allowed = allowedIps.split(',').map(s => s.trim().toUpperCase())
    return allowed.includes(countryCode.toUpperCase()) || allowed.includes(fullRegionCode)
  }
  if (restrictedIps) {
    const restricted = restrictedIps.split(',').map(s => s.trim().toUpperCase())
    return !restricted.includes(countryCode.toUpperCase()) && !restricted.includes(fullRegionCode)
  }
  return true
}
